import React from 'react';
import { AdvertisingSlot } from '@this/ads-prebid';

class FeedAd extends React.Component {

  shouldComponentUpdate(nextProps) {
    return this.props.lastRefreshTime !== nextProps.lastRefreshTime;
  }

  render() {
    let adSlotId = 'search_1';

    if (this.props.isAdvertisingRestricted) {
      adSlotId += '_restricted';
    }

    return <AdvertisingSlot id={adSlotId} {...this.props} />;
  }
}

export {
  FeedAd,
};
